import * as React from "react";
const SvgIcMenu = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M2 4.5H22V7.5H2V4.5ZM22 10.5H2V13.5H22V10.5ZM22 16.5H2V19.5H22V16.5Z" fill="currentColor" /></svg>;
export default SvgIcMenu;